export interface SeasonStage {
  id: string;
  name: string;
  description: string;
}

export interface Season {
  id: string;
  name: string;
  label: string;
  description: string;
  champion: string;
  matchCount: number;
  stages: SeasonStage[];
}

export const seasons: Season[] = [
  {
    id: "2025-26",
    name: "2025-26 赛季",
    label: "进行中",
    description:
      "全新赛制下的联赛阶段正在进行，36 支球队通过单循环积分争夺直接晋级 16 强的名额，竞争空前激烈。",
    champion: "待定",
    matchCount: 189,
    stages: [
      { id: "league", name: "联赛阶段", description: "36 队单循环积分赛，前 8 名直接晋级。" },
      { id: "playoff", name: "淘汰赛附加赛", description: "第 9 至 24 名捉对厮杀，争夺 16 强席位。" },
      { id: "r16", name: "16 强", description: "两回合主客场淘汰制。" },
      { id: "qf", name: "8 强", description: "强强对话，细节决定成败。" },
    ],
  },
  {
    id: "2024-25",
    name: "2024-25 赛季",
    label: "已结束",
    description:
      "巴黎圣日耳曼在决赛中击败国际米兰，捧起队史首座欧冠奖杯，成为赛季最大赢家。",
    champion: "巴黎圣日耳曼",
    matchCount: 189,
    stages: [
      { id: "league", name: "联赛阶段", description: "新赛制首季，联赛阶段 8 轮激战。" },
      { id: "r16", name: "16 强", description: "传统豪门悉数登场。" },
      { id: "qf", name: "8 强", description: "四场对决全部悬念保留。" },
      { id: "sf", name: "半决赛", description: "巴黎与国际米兰会师决赛。" },
    ],
  },
  {
    id: "2023-24",
    name: "2023-24 赛季",
    label: "已结束",
    description:
      "皇家马德里在决赛中击败多特蒙德，第 15 次将大耳朵杯带回伯纳乌。",
    champion: "皇家马德里",
    matchCount: 125,
    stages: [
      { id: "group", name: "小组赛", description: "传统 32 队 8 组双循环。" },
      { id: "r16", name: "16 强", description: "卫冕冠军稳步前行。" },
      { id: "qf", name: "8 强", description: "曼城与皇马再度相遇。" },
      { id: "f", name: "决赛", description: "皇马 2:0 击败多特蒙德。" },
    ],
  },
  {
    id: "2022-23",
    name: "2022-23 赛季",
    label: "已结束",
    description:
      "曼城在决赛中 1:0 战胜国际米兰，完成英超、足总杯、欧冠三冠王伟业。",
    champion: "曼城",
    matchCount: 125,
    stages: [
      { id: "group", name: "小组赛", description: "多支豪门提前出线。" },
      { id: "qf", name: "8 强", description: "曼城 4:1 淘汰拜仁。" },
      { id: "sf", name: "半决赛", description: "曼城 5:1 横扫皇马。" },
      { id: "f", name: "决赛", description: "罗德里一击制胜。" },
    ],
  },
];

export interface ScheduleDay {
  value: string;
  label: string;
}

export const scheduleDays: ScheduleDay[] = [
  { value: "all", label: "全部日期" },
  { value: "2026-10-15", label: "10 月 15 日" },
  { value: "2026-10-16", label: "10 月 16 日" },
  { value: "2026-10-17", label: "10 月 17 日" },
  { value: "2026-10-22", label: "10 月 22 日" },
];